import { Box } from "monday-ui-react-core";
import type { ReactElement } from "react";

type Props = {
  borderColor?: string;
  marginBottom?: string;
  backgroundColor?: string;
  paddingX?: string;
  children?: ReactElement | ReactElement[];
};

export function BorderedBox({
  borderColor = Box.borderColors.LAYOUT_BORDER_COLOR,
  marginBottom = Box.marginBottoms.LARGE,
  backgroundColor = Box.backgroundColors.PRIMARY_BACKGROUND_COLOR,
  paddingX = Box.paddingXs.LARGE,
  children,
}: Props) {
  return (
    <>
      <Box
        border={Box.borders.DEFAULT}
        borderColor={borderColor}
        marginBottom={marginBottom}
        backgroundColor={backgroundColor}
        paddingX={paddingX}
        paddingTop={Box.paddingYs.SMALL}
        paddingBottom={Box.paddingYs.MEDIUM}
        rounded={Box.roundeds.MEDIUM}
        shadow={Box.shadows.MEDIUM}
      >
        {children}
      </Box>
    </>
  );
}
